export default "/_next/static/data/businesses-investing-lottie.json-81cca5ae36ad97fc236e5fc133ff7192.json";